import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=0c15dd3d&scoped=true&lang=pug&"
var script = {}
import style0 from "./Notes.vue?vue&type=style&index=0&id=0c15dd3d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15dd3d",
  null
  
)

component.options.__file = "Notes.vue"
export default component.exports